//
//
//
//
//
//

export default {
    name: "aboutus",
  data(){
      return {
        richText:''
      }
  },
  created() {
      this.axios.post('/xcx/User/aboutus').then(res=>{
        this.richText=res.data.data;
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/aboutus/aboutus.vue